import { Attributes, LookupBase } from '@singularsystems/neo-core';

export default class LinkedInvestorInvestmentLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public investorInvestmentId: number = 0;

    public investor: string = "";

    public entityId: number = 0;

    @Attributes.Date()
    public investmentEndDate: Date | null = null;

    @Attributes.Integer()
    public noOfShares: number = 0;

    @Attributes.Float()
    public amount: number = 0;

    // Client only properties / methods
}